import { render, staticRenderFns } from "./FieldGroupReadonly.vue?vue&type=template&id=5966fc54&scoped=true"
import script from "./FieldGroupReadonly.vue?vue&type=script&lang=ts"
export * from "./FieldGroupReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966fc54",
  null
  
)

export default component.exports